export const UpsellingPendingStyles: { [key: string]: React.CSSProperties } = {
    alertContainer: {
        display: 'flex',
        borderRadius: 7,
        marginBottom: 25,
        overflow: 'hidden',
        backgroundColor: '#EAF1FF',
        border: '1px solid #0086D6',
    },
    alertIcon: {
        backgroundColor: '#184287',
        position: 'relative',
        padding: 10,
    },
    alertTextContainer: {
        flex: 1,
        display: 'flex',
        paddingLeft: 10,
        paddingRight: 10,
        alignItems: 'center',
        backgroundColor: '#EAF1FF',
        border: '1px solid #0086D6',
        justifyContent: 'space-between',
    },
    alertTextContent: {
        display: 'flex',
    },
    alertActionContent: {
        cursor: 'pointer',
        backgroundColor: 'transparent',
    },
    content: {
        display: 'flex',
        justifyItems: 'center',
        justifyContent: 'space-between',
    },
    contentLeft: {
        flex: 1,
        maxWidth: 600,
        minWidth: 350,
    },
    contentIcon: { display: 'flex', marginBottom: 15 },
    contentIconv2: {
        gap: 10,
        display: 'flex',
        marginBottom: 15,
        borderRadius: 999,
        alignItems: 'center',
        padding: '7px 15px',
        width: 'fit-content',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 134, 214, 0.1)',
    },
    contentCheck: {
        paddingTop: 17,
        paddingLeft: 17,
        borderRadius: 7,
        paddingRight: 17,
        paddingBottom: 10,
        backgroundColor: '#FFF',
        boxShadow: '0px 1px 3px 0px #00000040',
    },
    contentCheckv2: {
        gap: 30,
        display: 'flex',
        paddingTop: 17,
        paddingLeft: 17,
        borderRadius: 7,
        paddingRight: 17,
        flexWrap: 'wrap',
        paddingBottom: 10,
        backgroundColor: '#FFF',
    },
    checkItem: {
        display: 'flex',
        marginBottom: 10,
        alignItems: 'center',
    },
    actionsContainer: { marginBottom: 20 },
    btn1: {
        border: '1px solid #74BE00',
        backgroundColor: '#74BE00',
        cursor: 'pointer',
        borderRadius: 30,
        paddingRight: 17,
        paddingBottom: 7,
        paddingLeft: 17,
        paddingTop: 7,
        marginRight: 10,
        width: 177,
    },
    btn2: {
        backgroundColor: 'transparent',
        border: '1px solid #74BE00',
        cursor: 'pointer',
        borderRadius: 30,
        paddingRight: 17,
        paddingBottom: 7,
        paddingLeft: 17,
        paddingTop: 7,
        width: 177,
    },
}
